import { getLowerCaseLanguageCode } from '@mahawi/eshop-common/src/translation';
import { Space, Typography } from 'antd';
import React from 'react';

import { type IConfigState } from '../../reducers/config/types';
import { type ILanguageState } from '../../reducers/language/types';
import { SPACING } from '../../theme/tokens';
import CopyToClipboard from '../copy-to-clipboard';
import ExternalLink from '../external-link';

const { Text } = Typography;

interface IBasicOrderInfoProps {
  orderUuid: string;
  leadLanguageName: string;
  config: IConfigState;
  language: ILanguageState;
}

export const BasicOrderInfo = React.memo(function BasicOrderInfo({
  orderUuid,
  leadLanguageName,
  config,
  language,
}: IBasicOrderInfoProps): React.ReactElement {
  const uuidSegments: string[] = orderUuid.split('-');
  const firstSegment: string = uuidSegments[0];

  return (
    <Space size={SPACING.xs} orientation="vertical">
      <Space size={SPACING.xs} align="baseline">
        <Text>Lead language:</Text>
        <Text strong>{leadLanguageName}</Text>
      </Space>

      <Space size={SPACING.xs} align="baseline">
        <Text>Order UUID:</Text>
        <Text strong>{orderUuid}</Text>
        <CopyToClipboard text={orderUuid} type="link" />
        <ExternalLink
          to={`${config.url}/${getLowerCaseLanguageCode(language.languageType)}/order/${orderUuid}`}
          ariaLabel="Open order in new tab"
        />
      </Space>

      <Space size={SPACING.xs} align="baseline">
        <Text>Order short UUID:</Text>
        <Text strong>{firstSegment}</Text>
        <CopyToClipboard text={firstSegment} type="link" />
      </Space>
    </Space>
  );
});
